import { t } from 'localization/utils/t';

const TP = 'goatClean.enums.goatCleanEnums';

export const PAGE_DESCRIPTION = {
  value: t(
    `${TP}.goatCleanPageDescription`,
    'Shop GOAT Clean sneakers now on GOAT. Every sneaker is professionally cleaned and verified authentic by our team of trained specialists.',
  ),
  TK: 'goatCleanPageDescription',
  TP,
};

export const GOAT_CLEAN_SECTIONS = [
  {
    title: { value: t(`${TP}.section1Title`, 'Scrubbing the Shoes'), TK: 'section1Title', TP },
    description: {
      value: t(
        `${TP}.section1Description`,
        `We scrub every inch of these shoes so they come out spotless and looking like new.`,
      ),
      TK: 'section1Description',
      TP,
    },
    image: '/images/goat-clean/GOATCLEAN_1.jpg',
  },
  {
    title: { value: t(`${TP}.section2Title`, 'Rinsing the Laces'), TK: 'section2Title', TP },
    description: {
      value: t(`${TP}.section2Description`, `Each shoelace is rinsed clean with our solution.`),
      TK: 'section2Description',
      TP,
    },
    image: '/images/goat-clean/GOATCLEAN_2.jpg',
  },
  {
    title: { value: t(`${TP}.section3Title`, 'Washing the Insoles'), TK: 'section3Title', TP },
    description: {
      value: t(
        `${TP}.section3Description`,
        `We wash the insoles to ensure they look and feel fresh.`,
      ),
      TK: 'section3Description',
      TP,
    },
    image: '/images/goat-clean/GOATCLEAN_3.jpg',
  },
  {
    title: { value: t(`${TP}.section4Title`, 'Lint Removal'), TK: 'section4Title', TP },
    description: {
      value: t(`${TP}.section4Description`, `Lint is removed for a crisp inner lining.`),
      TK: 'section4Description',
      TP,
    },
    image: '/images/goat-clean/GOATCLEAN_4.jpg',
  },
  {
    title: { value: t(`${TP}.section5Title`, 'Smoothing the Creases'), TK: 'section5Title', TP },
    description: {
      value: t(
        `${TP}.section5Description`,
        `We carefully smooth out creases to make the shoes look like new.`,
      ),
      TK: 'section5Description',
      TP,
    },
    image: '/images/goat-clean/GOATCLEAN_5.jpg',
  },
  {
    title: { value: t(`${TP}.section6Title`, 'Grading the Sneakers'), TK: 'section6Title', TP },
    description: [
      {
        value: t(
          `${TP}.section6Description01`,
          'Our team of trained specialists assesses each pair of GOAT Clean shoes and assigns scores to specific areas. The scores are then combined for an overall grade.',
        ),
        TK: 'section6Description01',
        TP,
      },
      {
        value: t(`${TP}.section6Description02`, 'Like New: Minimal to no signs of wear.'),
        TK: 'section6Description02',
        TP,
      },
      {
        value: t(
          `${TP}.section6Description03`,
          'Excellent: Slight wear on tread with minimal creasing.',
        ),
        TK: 'section6Description03',
        TP,
      },
      {
        value: t(
          `${TP}.section6Description04`,
          'Very Good: Gentle wear with some creasing, scratches, and/or slight discoloration.',
        ),
        TK: 'section6Description04',
        TP,
      },
      {
        value: t(
          `${TP}.section6Description05`,
          'Good: Moderate wear with visible creasing, scuffing, and/or discoloration.',
        ),
        TK: 'section6Description05',
        TP,
      },
    ],
    image: '/images/goat-clean/GOATCLEAN_6.jpg',
  },
];

export const GOAT_CLEAN_HEADER_DATA = {
  title: {
    value: t(`${TP}.goatCleanHeaderTitle`, 'GOAT Clean'),
    TK: 'goatCleanHeaderTitle',
    TP,
  },
  count: 0,
  description: {
    value: t(
      `${TP}.goatCleanHeaderDescription`,
      'Fresh on your feet and easier on your wallet, GOAT Clean is our new program offering worn shoes that are professionally cleaned, graded and photographed. Each pair ships quickly and directly from us, and can be returned for site credit.',
    ),
    TK: 'goatCleanHeaderDescription',
    TP,
  },
  hasLink: true,
  linkTitle: {
    value: t(`${TP}.goatCleanHeaderLinkTitle`, 'View The GOAT Clean Process'),
    TK: 'goatCleanHeaderLinkTitle',
    TP,
  },
  linkDestination: '/goat-clean/process',
};
